<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Mensagens enviadas</span>
      <span class="titulo-contexto">
        O que o sistema mandou para o serviço de e-mail. <strong>POSTADA não é entregue</strong>:
        significa que a requisição saiu e o serviço respondeu sem erro — ele não confirma entrega.
      </span>
    </div>
    <button nbButton status="basic" size="medium" type="button" (click)="carregar()" title="Atualizar">
      <nb-icon pack="eva" icon="refresh-outline"></nb-icon>
      <span>Atualizar</span>
    </button>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar">
      <div class="filtro-toolbar-inline">
        <div class="filtro-turma-full">
          <label class="field-label" for="msgFiltro">Buscar</label>
          <nb-form-field>
            <nb-icon nbPrefix pack="eva" icon="search-outline"></nb-icon>
            <input
              nbInput
              fullWidth
              id="msgFiltro"
              name="msgFiltro"
              type="email"
              placeholder="E-mail ou nome do catequizando, da mãe ou do pai — Enter para buscar"
              [(ngModel)]="filtro"
              (keyup.enter)="buscarAgora()"
            />
          </nb-form-field>
        </div>
        <div class="campo-filtro--acoes">
          <button nbButton status="basic" size="small" type="button" (click)="buscarAgora()" title="Buscar agora" aria-label="Buscar agora">
            <nb-icon pack="eva" icon="search-outline"></nb-icon>
          </button>
        </div>
      </div>
    </div>

    <app-barra-carregando *ngIf="carregando"></app-barra-carregando>

    <div class="smart-table-wrap" *ngIf="mensagens.length">
      <table class="smart-table">
        <thead>
          <tr>
            <th appOrdenavel campo="criadoEm" rotuloAcessivel="Enviada em" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Enviada em</th>
            <th appOrdenavel campo="destinatario" rotuloAcessivel="Destinatário" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Destinatário</th>
            <th appOrdenavel campo="remetente" rotuloAcessivel="Remetente" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Remetente</th>
            <th appOrdenavel campo="assunto" rotuloAcessivel="Assunto" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Assunto</th>
            <th appOrdenavel campo="status" rotuloAcessivel="Situação" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Situação</th>
            <th class="col-num">Tentativas</th>
            <th class="col-acoes col-acoes--icones">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let m of mensagens">
            <td data-label="Enviada em">{{ m.criadoEm ? (m.criadoEm | date: 'dd/MM/yyyy HH:mm') : '—' }}</td>
            <td data-label="Destinatário">{{ m.destinatario || '—' }}</td>
            <td data-label="Remetente">{{ m.remetente || '—' }}</td>
            <td data-label="Assunto">{{ m.assunto || '—' }}</td>
            <td data-label="Situação">
              <span class="tag-status" [ngClass]="'tag-status--' + (m.status || '')">{{ m.status || '—' }}</span>
            </td>
            <td class="col-num" data-label="Tentativas">{{ m.tentativas != null ? m.tentativas : '—' }}</td>
            <td class="col-acoes col-acoes--icones" data-label="Ações">
              <div class="acao-btns acao-btns--inline" role="group">
                <button
                  type="button"
                  nbButton
                  size="small"
                  appearance="outline"
                  status="info"
                  class="btn-acao"
                  (click)="abrir(m)"
                  title="Abrir, editar parâmetros e reenviar"
                  aria-label="Abrir a mensagem"
                >
                  <nb-icon pack="eva" icon="eye-outline"></nb-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-lista-vazia
      *ngIf="!carregando && !mensagens.length"
      icone="email-outline"
      [filtrado]="temFiltro"
      mensagem="Nenhuma mensagem registrada ainda."
      mensagemFiltrado="Nenhuma mensagem para este destinatário."
      (verTodos)="limparFiltro()"
    ></app-lista-vazia>

    <div class="lista-paginacao" *ngIf="totalPages > 0">
      <button nbButton size="small" [disabled]="page === 1" (click)="onPageChange(page - 1)">Anterior</button>
      <span>Página {{ page }} de {{ totalPages }}</span>
      <button nbButton size="small" [disabled]="page === totalPages" (click)="onPageChange(page + 1)">Próxima</button>
    </div>
  </nb-card-body>
</nb-card>
